import Vue from 'vue'
import VueRouter from 'vue-router'
import Vinyl from './components/Vinyl.vue'
import ReRoute from './components/ReRoute.vue'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/brands/:brand_id/campaigns/:campaign_id/designer',
      component: Vinyl,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/re-route',
      name: 're-route',
      component: ReRoute,
    },
    {
      path: '/',
      name: 'vinyl',
      component: Vinyl,
      meta: {
        requiresAuth: true
      }
    }
  ],
  mode: 'history'
})

// router.beforeEach((to, from, next) => {
//   let currentUser = auth.currentUser;
//   let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//
//   if (requiresAuth && !currentUser) next('re-route')
//   else if (!requiresAuth && currentUser) next('vinyl')
//   else next()
// })

// export default router
